<template>
  <div>
    <p v-if="errorMessage" class="error-message text-danger">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    errorMessage: {},
  },
};
</script>
